var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 4,
    fill: "#3D405B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 4H12.5455C11.4605 4 10.4199 4.42143 9.65275 5.17157C8.88555 5.92172 8.45455 6.93913 8.45455 8V10.4H6V13.6H8.45455V20H11.7273V13.6H14.1818L15 10.4H11.7273V8C11.7273 7.78783 11.8135 7.58434 11.9669 7.43431C12.1204 7.28429 12.3285 7.2 12.5455 7.2H15V4Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.097ef8c3.svg";
export { ForwardRef as ReactComponent };